import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

function initHeroSlider(root = document) {
    const sliders = root.querySelectorAll('[data-hero-slider]');

    sliders.forEach((el) => {
        if (el.dataset.swiperInitialized === '1') return;
        el.dataset.swiperInitialized = '1';

        const paginationEl = el.querySelector('.block-hero-slider__pagination');
        const prevEl = el.querySelector('.block-hero-slider__nav--prev');
        const nextEl = el.querySelector('.block-hero-slider__nav--next');

        // eslint-disable-next-line no-new
        new Swiper(el, {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            loop: true,
            speed: 600,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false
            // },
            pagination: {
                el: paginationEl,
                clickable: true
            },
            navigation: {
                prevEl,
                nextEl
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', () => initHeroSlider());

// Podgląd w edytorze (ACF Block Preview)
if (window.acf) {
    window.acf.addAction('render_block_preview/type=hero-slider', (blockEl) => {
        initHeroSlider(blockEl);
    });
}
